import React, { useState } from "react";
import Logo from "../assets/images/Logo.png";
import { useHistory } from "react-router-dom";

function Navbar() {
  const [toggle, setToggle] = useState(false);
  const history = useHistory();
  const handleChange = () => {
    setToggle(!toggle);
  };
  return (
    <nav className="Navbar navbar navbar-expand-lg navbar-dark">
      <div className="container">
        {/* <ul className="navbar-nav ms-lg-4 ms-auto me-lg-0 me-4" style={{ flexDirection: "row" }}>
          <li className="nav-item">
            <a href="#" className="nav-link">
              <i className="fab fa-twitter"></i>
            </a>
          </li>
          <li className="nav-item">
            <a href="#" className="nav-link">
              <i className="fab fa-discord"></i>
            </a>
          </li>
        </ul> */}
        <button
          id="navbarToggle"
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={handleChange}
        >
          <i className={`far ${toggle ? "fa-times" : "fa-bars"}`}></i>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
            <li className="nav-item">
            
            </li>
           
            <li className="nav-item">
              <a className="nav-link" href="#gallery">
                GALLERY
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#team">
                TEAM
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link " href="#Roadmap">
                ROADMAP
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#story">
                STORY
              </a>
            </li>
            {/* <li className="nav-item">
              <a className="nav-link" href="#join">
                JOIN
              </a>
            </li>
            <li className="nav-item dropdown">
              <a
                className="dropdown-toggle dropToggle nav-link"
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                More
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                <li>
                  <a className="dropdown-item" href="#">
                    HOW TO MINIT
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    RARITY
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    CONTACT
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    CLUB
                  </a>
                </li>
              </ul>
            </li> */}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
